/**
 * 应用中心满包邮模块
 */
export const ApplyFullPackageArr = [
  {
    path: "fullPackage/:id(\\d+)",
    name: "fullPackage",
    meta: {
      title: "满包邮活动"
    },
    redirect: "/apply/fullPackage/:id(\\d+)/frlist",
    component: () => import("@/views/sidebar/itemFrame.vue"),
    children: [
      {
        path: "frlist",
        name: "frlist",
        meta: {
          title: "满包邮活动管理"
        },
        component: () =>
          import("@/views/apply/fullPackage/fullPackageSetting.vue")
      }
      // {
      //   path: "frlist",
      //   name: "frlist",
      //   meta: {
      //     title: "满包邮活动管理"
      //   },
      //   component: () =>
      //     import("@/views/apply/fullPackage/index.vue")
      // },
      // {
      //   path: "adActivity",
      //   name: "adActivity",
      //   meta: {
      //     title: "创建活动"
      //   },
      //   component: () =>
      //     import("@/views/apply/fullPackage/adActivity.vue")
      // },
    ]
  }
];
